"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "HelpdocsLogo___StyledSvg",
  componentId: "e050v8-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function HelpdocsLogo(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M286.667 263.34v-70L380 146.671v70l-93.333 46.668zm-210 77.155L240 401.746l163.333-61.25V91.104L250.43 167.546a23.277 23.277 0 01-20.86 0L76.667 91.105v249.39zM240 450c-2.777 0-5.553-.49-8.19-1.47L45.143 378.529C36.043 375.099 30 366.395 30 356.665V53.328c0-8.074 4.2-15.587 11.06-19.834a23.294 23.294 0 0122.703-1.027L240 120.575l176.237-88.108a23.291 23.291 0 0122.703 1.027A23.356 23.356 0 01450 53.328v303.337c0 9.73-6.043 18.434-15.143 21.864L248.19 448.53A23.513 23.513 0 01240 450z"
  }));
}

var _default = HelpdocsLogo;
exports["default"] = _default;